"use strict";

function ExecOnBlurDirective($document) {
  return {
    restrict: 'A',

    link: function($scope, $elem, $attrs) {
      $document.on('click', function(e) {
        if($elem.find(e.target).length === 0) {
          $scope.$evalAsync($attrs.execOnBlur);
        }
      });
    }

  };
}

angular.module('dokiv')
  .directive('execOnBlur', ['$document', ExecOnBlurDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ExecOnBlurDirective.js
// module id = 242
// module chunks = 0